<template>
  <div class="login" :style="bg">
    <div class="language-switch">
      <el-select v-model="currentLang" @change="handleLangChange" :placeholder="$t('app.login.language')">
        <el-option 
          v-for="(lang, key) in languageOptions" 
          :key="key" 
          :label="lang" 
          :value="key"
        ></el-option>
      </el-select>
    </div>
    <el-carousel height="160px">
      <el-carousel-item v-for="(item,index) in imgs" :key="index">
        <img :src="item.img" alt="" class="small">
      </el-carousel-item>
    </el-carousel>
    <el-form ref="loginForm" :model="form" :rules="rules" label-width="80px" class="login-box">
      <!-- <h3 class="login-title">{{ $t('app.login.title') }}</h3> -->
      <el-form-item :label="$t('app.login.username')" prop="username">
        <el-input type="text" :placeholder="$t('app.login.usernamePlaceholder')" v-model="form.username" style="width:80%"/>
      </el-form-item>
      <el-form-item :label="$t('app.login.password')" prop="password">
        <el-input type="password" :placeholder="$t('app.login.passwordPlaceholder')" autocomplete="off" v-model="form.password" style="width:80%" @keyup.enter.native="onSubmit"/>
      </el-form-item>
      <el-form-item :label="$t('app.login.imageCode')" prop="imageCode">
        <el-input type="text" :placeholder="$t('app.login.imageCodePlaceholder')" autocomplete="off" v-model="form.imageCode" style="width:50%" @keyup.enter.native="onSubmit"/>
        <span class="yanzheng">
          <img :src="imgSrc" alt="" :title="$t('app.login.refreshCode')"  @click="verification()">
        </span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit()">{{ $t('app.login.loginBtn') }}</el-button>
        <div class="card-query-container">
          <el-button type="text" @click="gotoCardQuery">{{ $t('app.login.searchCard') }}</el-button>
        </div>
      </el-form-item>
    </el-form>
    <div class="beianhao">
      <a href="https://beian.miit.gov.cn/" target="_blank">{{icp}}</a>
    </div>
  </div>
</template>
<script>
import { getCodeImg } from "@/api/login"; //引入login
import { loginPlatform } from "@/api/api.js"; 
export default {
  data() {
    return {
      languageOptions: {
        zh: "简体中文",  
        en: "English",
        pt: "Português"
      },
      redirect: undefined,
      loading: false,
      form: {
        username: "",
        password: "",
        imageCode: "",
        uuid: ""
      },
      imgSrc:"",
      jzMark:"",
      icp:'粤ICP备20053887号',
      imgs:[
        {
          img:require("../assets/img/tu1.png")
        },
        {
          img:require("../assets/img/tu1.png")
        }
      ],
      
      bg:"",
      currentLang: localStorage.getItem('app_language') || "zh", // 添加当前语言变量

    };
  },
  computed: {
    rules() {
      return {
        username: [
          { required: true, message: this.$t('app.login.usernameRequired'), trigger: "blur" }
        ],
        password: [
          { required: true, message: this.$t('app.login.passwordRequired'), trigger: "blur" }
        ],
        imageCode: [
          { required: true, message: this.$t('app.login.imageCodeRequired'), trigger: "blur" }
        ]
      };
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  
  methods: {
    handleLangChange(lang) {
      // 假设使用vue-i18n进行国际化
      this.$i18n.locale = lang;
      // 保存语言设置到本地存储
      localStorage.setItem('app_language', lang);
      if (this.$refs.loginForm) {
        
      }
    },
    verification(){
      getCodeImg().then(res => {
          this.imgSrc = "data:image/jpg;base64," + res.data.data.img;
          this.form.uuid = res.data.data.uuid;
      });
    },
    // 用户登陆
    onSubmit() {
      this.$refs.loginForm.validate(valid => {
          if (valid) {
            this.loading = true;
            this.$store.dispatch("Login", this.form).then(() => {
              this.$router.push({ path:"/" }).catch(()=>{});
              // this.$router.push({ path: this.redirect || "/" }).catch(()=>{});
            }).catch(() => {
              this.loading = false;
              this.verification();
            });
          }
        });
    },
    // 获取登陆背景图片
    initDataM2m(){
      let params ={
        domain:window.location.host
      }
      loginPlatform(params).then(res=>{
        if(res.data.code == 200){
          this.icp = res.data.data.icp;
          this.bg = { 
            background: 'url('+ res.data.data.url +') no-repeat center' ,
          }
        }
      })
    },
    gotoCardQuery() {
      // 这里假设跳转到卡号查询页面的路由是 '/card-query'
      this.$router.push('/web-card');
    }
  },
  mounted() {
    this.verification();
    this.initDataM2m();
    this.$i18n.locale = this.currentLang;
    this.$nextTick(() => {
      if (this.$refs.loginForm) {
        this.$refs.loginForm.clearValidate();
      }
    });
  },
};


</script>
<style scoped lang="less">
img{
  vertical-align:middle; 
  max-width:100%; 
  height:auto;
}
.login {
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.login-p {
  width: 1200px;
  text-align: center;
  font-size: 30px;
  color: #3e3e3e;
  margin-top: 40px;
}
.login-box {
  // border: 1px solid #dcdfe6;
  width: 400px;
  height: 285px;
  padding: 40px 35px 15px 35px;
  border-radius: 15px;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  box-shadow: 0 0 25px #909399;
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -155px;
  margin-left: -190px;
  // background: #8993af;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  // background: transparent;
}
.login-title {
  text-align: center;
  margin: 0 auto 20px auto;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
}
.el-button {
  width: 80%;
}
.el-button span {
  font-size: 16px;
}
.dialog-footer button {
  width: 70px;
  text-align: center;
  font-size: 14px;
}
.beianhao{
  position: absolute;
  bottom: 3%;
  font-size: 14px;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  left: 50%;
}
.yanzheng{
  display: inline-block;
  width: 25%;
  height: 37px;
  position: absolute;
  margin-left: 8px;
}
.yanzheng img{
  width: 100%;
  height: 100%;
}
/deep/ .el-carousel{
  display: none;
}

/* 添加语言切换按钮样式 */
.language-switch {
  position: absolute;
  top: 20px; /* 距离背景顶部20px */
  right: 20px; /* 距离背景右侧20px */
  z-index: 10; /* 确保在背景图片上方 */
  width: 120px; /* 适当加宽以容纳语言选项 */
}

.card-query-container {
  position: absolute;
  right: 50px;   /* 距离登录框右侧35px */
}


 @media screen and (max-width: 750px){
   .beianhao{
     display: none;
   }
   .login{
     background:none !important;
   }
    /deep/ .el-carousel{
        display: block;
      }
    /deep/ .el-carousel__container{
      // width: 90%;
      margin: 0 auto;
    }
    .login-title{
      display: none;
    }
   .login-box{
      width: 90%;
      height: 40%;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -30%;
      margin-left: -44%;
      background: none;
      border: none;
      padding: 0;
      box-shadow: 0 0 0 0;
   }
    .login-box h3{
      color:#fff;
      font-size: 20px;
    }
    .el-form-item__content{
        margin-left: 0;
    }
    .el-form-item{
        margin-bottom: 17px;
    }
    .el-button{
      background:#1989fa;
      border: none;
      color: #fff;
      font-weight: bold;
      font-size: 16px;
      width: 90%;
      margin-left: -18px;
    }

    .language-switch {
      position: absolute;
      top: 20px;
      right: 20px;
      margin-left: 0;
      width: 100px;
    }
    .card-query-container {
      bottom: 15px;  /* 移动端适当减小底部距离 */
      right: 20px;   /* 移动端适当减小右侧距离 */
    }
}
</style>

